import { render, staticRenderFns } from "./garden.vue?vue&type=template&id=af6f4c7c&scoped=true&"
import script from "./garden.vue?vue&type=script&lang=js&"
export * from "./garden.vue?vue&type=script&lang=js&"
import style0 from "./garden.vue?vue&type=style&index=0&id=af6f4c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f4c7c",
  null
  
)

export default component.exports